import React from 'react'
import { Box, Message, Text } from '@workwhile/ui'
import { Link } from 'react-router-dom'
import * as ROUTES from 'constants/routes'
import { useIndeedFlexAuthStatusQuery } from 'queries/admin/indeedFlex/useIndeedFlexAuthStatusQuery'

type IndeedFlexAuthStatusBannerProps = {
  showWhenLive?: boolean
}

export const IndeedFlexAuthStatusBanner = ({
  showWhenLive = false,
}: IndeedFlexAuthStatusBannerProps) => {
  const { data, isPending, isError } = useIndeedFlexAuthStatusQuery()

  if (isPending || isError || !data) {
    return null
  }

  if (data.sessionReady) {
    if (!showWhenLive) {
      return null
    }
    return (
      <Box mx={3} mt={3}>
        <Message variant="success" borderRadius="small">
          Indeed Flex session is live.
        </Message>
      </Box>
    )
  }

  const reason = data.errorMessage ? ` (${data.errorMessage})` : ''

  return (
    <Box mx={3} mt={3}>
      <Message variant="warning" borderRadius="small">
        {showWhenLive ? (
          <Text>Indeed Flex session is not live{reason}.</Text>
        ) : (
          <Text>
            Indeed Flex session is not live{reason}. Sync stays blocked until an
            admin restores it on the{' '}
            <Link to={ROUTES.INDEED_FLEX_OTP}>email code</Link> page.
          </Text>
        )}
      </Message>
    </Box>
  )
}
